<template>
    <div>
      <h2>Aktivace proběhla úspěšně.</h2>
      <div>Probíhá přesměrování.</div>
    </div>
</template>

<script>
export default {
  name: 'VerificationSuccess',
  created () {
    setTimeout(() => {
      this.$router.push({ name: 'login' })
    }, 2000)
  }
}
</script>

<style scoped>

</style>
